import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import AddressStore, { addressModel } from './AddressStore';

import { Whitespace, View, Text } from '../common';
import InputHeader from '../common/FormComponents/InputHeader';
import Input from '../common/FormComponents/InputStyle';
import Button from '../common/FormComponents/Button';
import Checkbox from '../common/FormComponents/Checkbox';

@observer
class AddressSelect extends Component {
  @observable addressStore = AddressStore.create({});
  @observable adding = null;

  componentDidUpdate() {
    const { selected } = this.props;
    if (selected && selected.length > 0) {
      this.addressStore.initialSelection(selected);
    }
  }

  edit = itm => {
    this.addressStore.edit(itm);
  };

  select = itm => {
    const { onSelectionChanged, single } = this.props;
    this.addressStore.selectAddress(itm, single);
    if (onSelectionChanged) {
      onSelectionChanged(this.addressStore.selectedAddressesJS);
    }
  };

  onAdded = addr => {
    if (addr) {
      this.select(addr);
    }
  };

  render() {
    const store = this.addressStore;
    const { modifying, focusedAddress } = store;
    return (
      <div className="f f-rows f-1 h-min-300">
        <Whitespace />
        <View className="g g-g-m g-tc-fr-3" if={!modifying}>
          {store.addresses.map(a => (
            <AddressCard
              store={a}
              edit={this.edit}
              select={this.select}
              noSelect={this.props.noSelect}
            />
          ))}
        </View>
        <View if={modifying}>
          <AddAddress store={focusedAddress} onAdded={this.onAdded} />
        </View>
        <Whitespace medium />
        <View if={!modifying} className="f-self-start">
          <button className="bg-transparent b-0 f-sc" onClick={store.startAdd}>
            <i className="fal fa-plus fa-2x mr-s primaryDark" />
            <Text t-l inline primaryDark clickable>
              Add a new address
            </Text>
          </button>
        </View>
        <Whitespace />
      </div>
    );
  }
}

export default AddressSelect;

@observer
class AddressCard extends Component {
  @observable hovering = false;

  edit = () => {
    const { edit, store } = this.props;
    edit(store);
  };
  select = () => {
    const { select, store } = this.props;
    select(store);
  };

  render() {
    const { store, noSelect } = this.props;
    const bColor = store.selected ? 'b-1 b-primaryDark' : '';
    return (
      <div
        className={'brad-m sh-default bg-white p-mxx m-sxx relative f-sc ' + bColor}
        onMouseEnter={() => (this.hovering = true)}
        onMouseLeave={() => (this.hovering = false)}
      >
        <View className="f f-columns ">
          <View className="f f-cc" if={!noSelect}>
            <Checkbox
              label=""
              onChange={this.select}
              checked={store.selected}
            />
          </View>
          <View>
            <Text primaryDark h6 >
              {store.label.value}
            </Text>
            <Text >{store.addrStr1}</Text>
            <Text >{store.addrStr2}</Text>
            <View
              if={this.hovering}
              className="absolute right--15 top-0 bottom-0 bg-transparent f-rows f f-around-center"
            >
              <button
                className="sh-default brad-full p-sx b-0 h-30 w-30"
                onClick={this.edit}
              >
                <i className="fal fa-pencil primaryDark" />
              </button>
            </View>
          </View>
        </View>
      </div>
    );
  }
}

@observer
class AddAddress extends Component {
  save = async () => {
    const { onAdded, store } = this.props;
    await store.save();
    if (onAdded) {
      onAdded(store);
    }
  };

  render() {
    const { store } = this.props;
    if (!store) {
      return null;
    }
    return (
      <View>
        <InputHeader label="Label" error={store.label.error} />
        <Input
          onChange={e => store.label.set(e.target.value)}
          value={store.label.value}
          placeholder="Home, office, storage, etc"
          onFocus={store.label.touch}
        />

        <Whitespace smaller />

        <InputHeader label="Street Address" error={store.street.error} />
        <Input
          onChange={e => store.street.set(e.target.value)}
          value={store.street.value}
          placeholder="Street Address"
          onFocus={store.street.touch}
        />

        <Whitespace smaller />

        <InputHeader
          label="Apt, suite, Bldg, (optional)"
          error={store.buildingName.error}
        />
        <Input
          onChange={e => store.buildingName.set(e.target.value)}
          value={store.buildingName.value}
          placeholder="Apt, suite, Bldg, (optional)"
          onFocus={store.buildingName.touch}
        />

        <Whitespace smaller />

        <div className="g g-tc-fr-2 g-g-l">
          <div>
            <InputHeader label="City" error={store.city.error} />
            <Input
              onChange={e => store.city.set(e.target.value)}
              value={store.city.value}
              placeholder="City"
              onFocus={store.city.touch}
            />
          </div>

          <div>
            <InputHeader label="State" error={store.state.error} />
            <Input value="UT" placeholder="State" />
          </div>
        </div>

        <Whitespace smaller />
        <InputHeader label="Zipcode" error={store.zipcode.error} />
        <Input
          onChange={e => store.zipcode.set(e.target.value)}
          value={store.zipcode.value}
          placeholder="Zipcode"
          onFocus={store.zipcode.touch}
        />
        <Whitespace smaller />
        <View className="f-between-center">
          <Button secondary muted onClick={store.cancelAdd}>
            Cancel
          </Button>
          <Button primary onClick={this.save}>
            Save
          </Button>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/addresses/AddressSelect.js